<template>
  <d-card class="mb-5 has-box-show is-border-radius-10">
    <d-card-row>
      <p class="has-text-weight-semibold mb-1 is-size-7 is-custom-grey">
        {{ $t("promotion").capitalize() }}
      </p>

      <!-- Crédit mensuel : promotional rent + regular rent -->
      <template v-if="promotion.type === 'monthly_credit'">
        <p class="is-size-7 has-text-weight-medium mb-1">
          {{ $t("promotion_credit_tooltip_line1", { price: promotion.display_price }) }}
        </p>
        <p class="is-size-7 has-text-weight-medium">
          {{ $t("promotion_credit_tooltip_line2", { price: promotion.regular_price }) }}
        </p>
      </template>

      <!-- Mois gratuit fixe : which month is offered -->
      <template v-else-if="promotion.type === 'free_month'">
        <p class="is-size-7 has-text-weight-medium mb-1">
          {{ $t("promotion_free_month_tooltip") }}
        </p>
        <p
          v-if="promotion.free_month"
          class="is-size-7 has-text-weight-medium"
        >
          {{ $t("promotion_free_month_which", { month: $t("promotion_month_" + promotion.free_month) }) }}
        </p>
      </template>

      <!-- Autre : free text entered by the admin -->
      <p
        v-else
        class="is-size-7 has-text-weight-medium promo-free-text"
        style="white-space: pre-line"
      >{{ promotion.text }}</p>
    </d-card-row>
  </d-card>
</template>

<script>
export default {
  props: {
    promotion: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style scoped>
.promo-free-text {
  white-space: pre-line;
}
</style>
